<template>
  <section class="p-3 relative h-screen overflow-hidden">
    <Carousel :numberOfSlides="1" :wantArrows="false" :autoplay="true">
      <div v-for="i in bannerImages.length" :key="i">
        <img
          :src="require(`@/assets/img/${bannerImages[i-1]}`)"
          alt=""
          class="rounded-lg relative"
        />
        <div class="absolute top-0 mb-4 p-6 pl-8">
          <p
            class="text-3xl font-semibold leading-9 tracking-tighter text-white w-7/12"
          >
            {{ bannerHeaderText }}
          </p>
          <p
            class="mt-5 text-white font-normal leading-5 tracking-tight text-sm w-11/12"
          >
            Learn how you can start your fitness journey <br />
            from the comfort of your own home
          </p>
        </div>
      </div>
    </Carousel>
  </section>
</template>

<script>
import { Carousel } from "@/components/t-components";
export default {
  components: {
    Carousel,
  },
  props: {
    bannerImages: {
      type: Array,
    },
    bannerHeaderText: {
      type: String,
    },
  },
};
</script>

